import { CTABannerRefProjection } from '../references/CTABannerRef.query';

export const queryTechTip = groq`*[ _type == "techTip" && currentPathname == $currentPathname][0]{
    ...,
  "blogHero": {
    title,
    "backgroundImg": heroImage,
    heroImage {
      asset-> {
        altText
      }
    },
    "date":articleDate,
    readTime,
    taxonomies[]->,
     person {
      reference->
    }
  },
  CTABanner {
    reference-> ${CTABannerRefProjection}
  },
}`;
